var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.facetsType,{tag:"compontent",attrs:{"type":_vm.topic,"name":_vm.name,"options":_vm.options,"device":_vm.device,"min-value":_vm.minValueRangeSlider,"max-value":_vm.maxValueRangeSlider},on:{"selected":_vm.setFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }